export const mockCheckoutMeta = {
  storeOrder: {
    id: '8a8194717b5f4500017b61632572079f',
    storeId: '8a8197d678da02e40178e3da3a6605af',
    storeName: 'Example',
    storeAddress: 'Oddle Eats',
    menuId: '8a8197d678da02e40178e3da39f70584',
    menuName: 'Example',
    isPickup: true,
    orderNumber: '000001',
    orderDate: '20 Aug 2021',
    orderDateRank: 1629426577000,
    orderTime: '10:29 AM',
    collectionDate: '20 Aug 2021',
    collectionTime: '11:15 AM to 11:30 AM',
    earliestCollectionTime: '20 08 2021',
    subtotal: 10,
    total: 10,
    currencyCode: 'SGD',
    orderItems: [
      {
        'id': '2c9f848064b2307c0164ca54c10513d9',
        'price': 13.9,
        'name': 'Sample Product 1',
        'status': 0,
        'muteUntil': null,
        'collectionStartDate': null,
        'collectionEndDate': null,
        'collectionStartTime': null,
        'collectionEndTime': null,
        'availableDays': null,
        'isValid': true,
        'isPromotionalItem': false,
        'promotionReference': null,
        'promotionName': null,
        'quantity': 2,
        'itemReference': '2c9f8fb15494473b015494af94f3027b',
        'subitemChoices': null
      },
      {
        'id': '2c9f848064b2307c0164ca54c1051310',
        'price': 10.5,
        'name': 'Sample Product 2',
        'status': 0,
        'muteUntil': null,
        'collectionStartDate': null,
        'collectionEndDate': null,
        'collectionStartTime': null,
        'collectionEndTime': null,
        'availableDays': null,
        'isValid': true,
        'isPromotionalItem': false,
        'promotionReference': null,
        'promotionName': null,
        'quantity': 1,
        'itemReference': '2c9f8fb15494473b015494af94f3027b',
        'subitemChoices': null
      }
    ]
  },
  customer: {}
}

export const mockCheckoutResult = {
  id: '8a8194717b5f4500017b61632572079f',
  storeId: '8a8197d678da02e40178e3da3a6605af',
  storeName: 'Example',
  defaultStoreId: null,
  menuId: '8a8197d678da02e40178e3da39f70584',
  menuName: 'Example',
  isPickup: true,
  deliveryAddressAutoComplete: null,
  deliveryAddress: null,
  deliveryAddressOne: null,
  deliveryAddressTwo: null,
  deliveryAddressCity: null,
  deliveryAddressState: null,
  deliveryAddressPostal: null,
  deliveryAddressCountry: null,
  deliveryInstructions: null,
  deliveryAddressType: 'building',
  deliveryAddressTwoDetails: {
    buildingName: '',
    unitNumber: null
  },
  customerLatitude: null,
  customerLongitude: null,
  subtotal: 10,
  total: 10,
  deliveryCost: 0,
  deliveryFreeAfter: 0,
  locationDeliveryCost: 0,
  surchargeDeliveryCost: 0,
  remainingAmountToFreeDelivery: 0,
  minimumOrder: 0,
  maximumOrder: null,
  roundingAdjustment: 0,
  storeAddress: 'Oddle Eats',
  orderNumber: '000001',
  orderDate: '20 Aug 2021',
  orderDateRank: 1629426577000,
  orderTime: '10:29 AM',
  collectionDate: '20 Aug 2021',
  collectionTime: '11:15 AM to 11:30 AM',
  earliestCollectionTime: '20 08 2021',
  currencyCode: 'SGD',
  totalAmountInSubUnit: 100,
  status: 2,
  orderPromotions: null,
  taxAndCharges: null,
  orderItems: [
    {
      id: '8a8194717b5f4500017b6163492a07a0',
      price: 10,
      name: 'Sample Item',
      status: 0,
      muteUntil: null,
      collectionStartDate: null,
      collectionEndDate: null,
      collectionStartTime: null,
      collectionEndTime: null,
      availableDays: null,
      isValid: true,
      isPromotionalItem: false,
      promotionReference: null,
      promotionName: null,
      quantity: 1,
      itemReference: '8a8197d678da02e40178e3da3b6405bb',
      itemId: '8a8197d678da02e40178e3da3b5c05ba',
      subitemChoices: null
    }
  ],
  deliveryRequestDto: null,
  token: 'MniclZOGqb6dqe2RdCjoNKm68R4DDawaRujHPI0lsOc',
  storeOrderPaymentDetails: {
    id: '8a8194717b5f4500017b61646c5007aa',
    accessKey: null,
    version: null,
    createdOn: '2021-08-20 10:29:36',
    paymentStatus: 'PAID',
    paymentProcessReference: 'pm_1JQNU9Lvc0onZ7sfmRtPyalr',
    paymentReference: 'pi_3JQNUBLvc0onZ7sf0yBRXnmY',
    storeOrderTotalAmount: 10,
    paymentAmount: 10,
    refundAmount: 0,
    network: 'VISA',
    issuer: 'THE CHASE MANHATTAN BANK',
    paymentMethod: 'Credit Card',
    transactionReference: null
  },
  orderVouchers: null,
  pickup: true
}

export const mockPaymentOptions = {
  payload: {
    paymentOptions: [
      {
        id: '8a8194668600cca5018606643a222acc',
        accessKey: null,
        version: null,
        menuId: null,
        type: 20,
        paymentName: 'Credit/Debit Card Payment',
        privateInformation: null,
        publicInformation: null,
        clientId: 'pk_test_51H0XHBLvc0onZ7sfksdS8y444HKjaOIMAiv8QVTElsIs4c2WiFotiHfK0f7ZLQ0M7EP04yHZNLPSSFSw6U6wlyMV00fpmcQJtc',
        clientSecret: null,
        displayOnShoppingCart: null,
        isEnabled: null,
        accountNumber: 'acct_1MWCnfQ37z061Q87',
        paymentLinkStatus: null,
        status: null,
        secretHash: null,
        paymentDropName: null,
        isEnabledThreeDomainSecure: null,
        useStripeSource: null,
        groupId: null,
        isEnabledChinatrustRedirect: true,
        isHelpbuyEnabled: null,
        isStripePaymentRequestButtonEnabled: false,
        isStripeDirectCharge: false,
        enableOnCheckout: true,
        paymentMethod: null,
        paymentGateway: null,
        stripeAccountDto: null,
        availablePaymentMethods: null,
        connectedBrandDtos: null,
        paymentProcessToken: 'pk_test_51H0XHBLvc0onZ7sfksdS8y444HKjaOIMAiv8QVTElsIs4c2WiFotiHfK0f7ZLQ0M7EP04yHZNLPSSFSw6U6wlyMV00fpmcQJtc',
        storePaymentOptionDtos: null
      },
      {
        id: '2c9f8f056518fbe801653ba169fd2d17',
        accessKey: null,
        version: null,
        menuId: null,
        type: 0,
        paymentName: 'Offline Payment',
        privateInformation: null,
        publicInformation: 'For pickup, please proceed to cashier for payment and quote your order number.<div><br></div><div>For delivery, please note that your orders won\'t be processed until payment is made to POSB 113-109-19-1 at least 2 hours before your order is made.</div>',
        clientId: null,
        clientSecret: null,
        displayOnShoppingCart: null,
        isEnabled: null,
        accountNumber: null,
        paymentLinkStatus: null,
        status: null,
        secretHash: null,
        paymentDropName: null,
        isEnabledThreeDomainSecure: null,
        useStripeSource: null,
        groupId: null,
        isEnabledChinatrustRedirect: true,
        isHelpbuyEnabled: null,
        isStripePaymentRequestButtonEnabled: null,
        isStripeDirectCharge: null,
        enableOnCheckout: true,
        paymentMethod: null,
        paymentGateway: null,
        stripeAccountDto: null,
        availablePaymentMethods: null,
        connectedBrandDtos: null,
        paymentProcessToken: 'For pickup, please proceed to cashier for payment and quote your order number.<div><br></div><div>For delivery, please note that your orders won\'t be processed until payment is made to POSB 113-109-19-1 at least 2 hours before your order is made.</div>',
        storePaymentOptionDtos: null
      }
    ]
  }
}
